import { useAnalyticsClient } from '../../../../../../../../analytics/wac-analytics/analytics-client';

import { useCloudStatus } from '../../hooks/use-cloud-status';

import { useEffect } from 'react';
import { tenantType } from '@atlassiansox/analytics-web-client';

export const AnalyticsClientUpdater = () => {
	const { cloudId } = useCloudStatus();
	const analyticsClient = useAnalyticsClient();

	useEffect(() => {
		if (!analyticsClient || !cloudId) {
			return;
		}

		analyticsClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
	}, [analyticsClient, cloudId]);

	return null;
};
